import * as actionTypes from './action-types';

const STORAGE_KEY = 'comparisonFilterSettings';

const DEFAULT_SELECTION = {
  turbine_data_id: null,
  forecast_config_id: null,
  prod_forecast_id: null
};

export const DEFAULT_COMPARISON_FILTERS = {
  from: null,
  to: null,
  calculated: 'all',
  location_id: null,
  selection1: { ...DEFAULT_SELECTION },
  selection2: { ...DEFAULT_SELECTION }
};

const normalizeSelection = (selection) => ({
  turbine_data_id: selection?.turbine_data_id ?? null,
  forecast_config_id: selection?.forecast_config_id ?? null,
  prod_forecast_id: selection?.prod_forecast_id ?? null
});

const loadStoredComparison = () => {
  if (typeof window === 'undefined') {
    return { ...DEFAULT_COMPARISON_FILTERS };
  }

  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return { ...DEFAULT_COMPARISON_FILTERS };
    }

    const parsed = JSON.parse(raw);

    return {
      from: parsed.from ?? null,
      to: parsed.to ?? null,
      calculated: parsed.calculated ?? 'all',
      location_id: parsed.location_id ?? null,
      selection1: normalizeSelection(parsed.selection1),
      selection2: normalizeSelection(parsed.selection2)
    };
  } catch {
    return { ...DEFAULT_COMPARISON_FILTERS };
  }
};

const persistComparison = (filters) => {
  if (typeof window === 'undefined') return;

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filters));
  } catch {
    // ignore quota / private mode errors
  }
};

const storedComparison = loadStoredComparison();

export const initialState = {
  filters: storedComparison
};

const comparisonReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_COMPARISON_FILTERS: {
      const next = {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
          selection1: normalizeSelection({
            ...state.filters.selection1,
            ...action.payload.selection1
          }),
          selection2: normalizeSelection({
            ...state.filters.selection2,
            ...action.payload.selection2
          })
        }
      };
      persistComparison(next.filters);
      return next;
    }
    default:
      return state;
  }
};

export default comparisonReducer;
